import { LATERAL_STATUS_COLORS, getLateralStatusLabel } from "@/lib/lateral-statuses";

interface Props {
  status: string;
  className?: string;
}

export function LateralStatusBadge({ status, className = "" }: Props) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
        LATERAL_STATUS_COLORS[status] ?? "bg-gray-100 text-gray-700"
      } ${className}`}
    >
      {getLateralStatusLabel(status)}
    </span>
  );
}
